"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createColDefsFromTableDescriptor = void 0;
var tslib_1 = require("tslib");
var findIndex_1 = tslib_1.__importDefault(require("lodash/findIndex"));
var constants_1 = require("../base/constants");
var tableDescriptorTypes_1 = require("./tableDescriptorTypes");
var sdk_model_1 = require("@gooddata/sdk-model");
var colSortItemMatching_1 = require("./colSortItemMatching");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var sdk_ui_1 = require("@gooddata/sdk-ui");
function getSortProp(initialSorts, predicate) {
    var sortIndex = findIndex_1.default(initialSorts, function (s) { return predicate(s); });
    var sort = initialSorts[sortIndex];
    return sort
        ? {
            sort: sdk_model_1.sortDirection(sort),
            // use sortedAt to make sure the order of sorts is the same as the order of columns
            sortedAt: sortIndex,
        }
        : {};
}
function createAndAddSliceColDefs(rows, state) {
    var _loop_1 = function (row) {
        var sortProp = getSortProp(state.initialSorts, function (s) { return colSortItemMatching_1.attributeSortMatcher(row, s); });
        var cellRendererProp = !state.cellRendererPlaced ? { cellRenderer: "loadingRenderer" } : {};
        var colDef = tslib_1.__assign(tslib_1.__assign({ type: constants_1.ROW_ATTRIBUTE_COLUMN, colId: row.id, field: row.id, headerName: row.attributeDescriptor.attributeHeader.formOf.name }, cellRendererProp), sortProp);
        state.rowColDefs.push(colDef);
        state.allColDefs.push(colDef);
        if (!state.cellRendererPlaced) {
            state.cellRendererPlaced = colDef;
        }
    };
    for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
        var row = rows_1[_i];
        _loop_1(row);
    }
}
function createColumnGroupColDef(col, state) {
    var children = createColumnHeadersFromDescriptors(col.children, state);
    if (children.length === 0) {
        var colDef = {
            type: constants_1.COLUMN_ATTRIBUTE_COLUMN,
            colId: col.id,
            headerName: sdk_ui_vis_commons_1.valueWithEmptyHandling(sdk_ui_1.getMappingHeaderFormattedName(col.header), state.emptyHeaderTitle),
        };
        state.allColDefs.push(colDef);
        state.leafColDefs.push(colDef);
        return colDef;
    }
    else {
        var colGroup = {
            groupId: col.id,
            headerName: sdk_ui_vis_commons_1.valueWithEmptyHandling(sdk_ui_1.getMappingHeaderFormattedName(col.header), state.emptyHeaderTitle),
            children: children,
        };
        state.allColDefs.push(colGroup);
        return colGroup;
    }
}
function createColumnHeadersFromDescriptors(cols, state) {
    var colDefs = [];
    var _loop_2 = function (col) {
        switch (col.type) {
            case "rootCol": {
                var colDef = {
                    groupId: tableDescriptorTypes_1.ColumnGroupingDescriptorId,
                    children: createColumnHeadersFromDescriptors(col.children, state),
                    headerName: col.groupingAttributes
                        .map(function (attr) { return attr.attributeHeader.formOf.name; })
                        .join(constants_1.COLUMN_GROUPING_DELIMITER),
                };
                colDefs.push(colDef);
                state.allColDefs.push(colDef);
                break;
            }
            case "scopeCol": {
                colDefs.push(createColumnGroupColDef(col, state));
                break;
            }
            case "seriesCol": {
                var sortProp = getSortProp(state.initialSorts, function (s) { return colSortItemMatching_1.measureSortMatcher(col, s); });
                var cellRendererProp = !state.cellRendererPlaced ? { cellRenderer: "loadingRenderer" } : {};
                var colDef = tslib_1.__assign(tslib_1.__assign({ type: constants_1.MEASURE_COLUMN, colId: col.id, field: col.id, headerName: col.seriesDescriptor.measureTitle() }, sortProp), cellRendererProp);
                colDefs.push(colDef);
                state.leafColDefs.push(colDef);
                state.allColDefs.push(colDef);
                if (!state.cellRendererPlaced) {
                    state.cellRendererPlaced = colDef;
                }
                break;
            }
        }
    };
    for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
        var col = cols_1[_i];
        _loop_2(col);
    }
    return colDefs;
}
function createAndAddDataColDefs(table, state) {
    var _a;
    var cols = createColumnHeadersFromDescriptors(table.rootDataCols, state);
    (_a = state.rootColDefs).push.apply(_a, cols);
}
//
//
//
/**
 * Given table column descriptors & list of sort items, this function will create ag-grid ColDefs which mirror
 * the column descriptor. Any ColDefs whose descriptors match the sortItems will have the sorts set according
 * to the matching sort item.
 *
 * @param table - table col descriptors
 * @param initialSorts - initial table sorting definition
 * @param emptyHeaderTitle - what to show for title of headers with empty title
 */
function createColDefsFromTableDescriptor(table, initialSorts, emptyHeaderTitle) {
    var state = {
        initialSorts: initialSorts,
        cellRendererPlaced: undefined,
        rootColDefs: [],
        allColDefs: [],
        leafColDefs: [],
        rowColDefs: [],
        emptyHeaderTitle: emptyHeaderTitle,
    };
    createAndAddSliceColDefs(table.sliceCols, state);
    createAndAddDataColDefs(table, state);
    var idToColDef = {};
    state.allColDefs.forEach(function (colDef) { return (idToColDef[tableDescriptorTypes_1.agColId(colDef)] = colDef); });
    return {
        sliceColDefs: state.rowColDefs,
        rootDataColDefs: state.rootColDefs,
        leafDataColDefs: state.leafColDefs,
        idToColDef: idToColDef,
    };
}
exports.createColDefsFromTableDescriptor = createColDefsFromTableDescriptor;
//# sourceMappingURL=colDefFactory.js.map